export const _renderCurrency = (value) => {
  if (value === '' || value === null || value === undefined) return '';
  let number = Number(value);
  if (isNaN(number)) return '';
  return number?.toLocaleString('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
};

export const _renderNumeric = (value, maxFragtionDigits = 0) => {
  if (value === '' || value === null || value === undefined) return '';
  let number = Number(value);
  if (isNaN(number)) return '';
  return number?.toLocaleString('id-ID', {
    maximumFractionDigits: maxFragtionDigits,
    minimumFractionDigits: 0,
  });
};

export const terbilang = (nominal) => {
  const angka = Math.floor(Math.abs(Number(nominal) || 0));
  if (angka === 0) return 'Nol Rupiah';

  const satuan = ['', 'Satu', 'Dua', 'Tiga', 'Empat', 'Lima', 'Enam', 'Tujuh', 'Delapan', 'Sembilan', 'Sepuluh', 'Sebelas'];

  function toWords(n) {
    if (n < 12) return satuan[n];
    if (n < 20) return toWords(n - 10) + ' Belas';
    if (n < 100) return toWords(Math.floor(n / 10)) + ' Puluh ' + toWords(n % 10);
    if (n < 200) return 'Seratus ' + toWords(n - 100);
    if (n < 1000) return toWords(Math.floor(n / 100)) + ' Ratus ' + toWords(n % 100);
    if (n < 2000) return 'Seribu ' + toWords(n - 1000);
    if (n < 1000000) return toWords(Math.floor(n / 1000)) + ' Ribu ' + toWords(n % 1000);
    if (n < 1000000000) return toWords(Math.floor(n / 1000000)) + ' Juta ' + toWords(n % 1000000);
    if (n < 1000000000000) return toWords(Math.floor(n / 1000000000)) + ' Miliar ' + toWords(n % 1000000000);
    return toWords(Math.floor(n / 1000000000000)) + ' Triliun ' + toWords(n % 1000000000000);
  }

  return toWords(angka).replace(/\s+/g, ' ').trim() + ' Rupiah';
};
